import React from 'react';
import { BaseLayerView } from '@/framework';
import { type ITextLayerProps } from '@/version-types';
import { type TextLayerProps } from '../types';
import Screenshot from './screenshot';
import ShapeText from './shape-text';
import SVGTextRenderer from './svg-text-renderer';

const TextLayer: React.FC<TextLayerProps> = (props) => {
    const { layer, isNavigator } = props;

    const layerData = layer.data as ITextLayerProps;
    const { shapeExtension } = layerData;

    const renderGLCanvas = layer.__renderGLCanvas;
    const renderShapeText = renderGLCanvas && shapeExtension && !isNavigator;
    const renderScreenshot = !renderGLCanvas && shapeExtension;

    if (renderShapeText) {
        return <ShapeText {...props} />;
    }

    if (renderScreenshot) {
        return <Screenshot {...props} />;
    }

    return (
        <BaseLayerView layer={layer} isNavigator={isNavigator}>
            <SVGTextRenderer {...props} />
        </BaseLayerView>
    );
};

export default React.memo(TextLayer);
